import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Privacy from "./pages/Privacy";
import AMLKYC from "./pages/AMLKYC";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import Register from "./pages/Register";
import VerifyOtp from "./pages/VerifyOtp";
import SignupSuccess from "./pages/SignupSuccess";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import TransactionHistory from "./pages/TransactionHistory";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "./lib/AdminAuthContext";
import { UserAuthProvider } from "./lib/UserAuthContext";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProtected from "./components/AdminProtected";
import UserProtected from "./components/UserProtected";

function App() {
  return (
    <UserAuthProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:slug" element={<BlogDetail />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/aml-kyc" element={<AMLKYC />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            {/* User auth + dashboard */}
            <Route path="/register" element={<Register />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/signup-success" element={<SignupSuccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<UserProtected><Dashboard /></UserProtected>} />
            <Route path="/history" element={<UserProtected><TransactionHistory /></UserProtected>} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminProtected><AdminDashboard /></AdminProtected>} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AdminAuthProvider>
    </UserAuthProvider>
  );
}

export default App;
